import React from 'react';
import classNameBind from 'classnames/bind';
import Tabs from '../Tabs';
import styles from './AppMenu.module.css';

const bindClasses = classNameBind.bind(styles);

const AppMenu = ({ tabs, children, RouterLink, routerMode }) => (
  <div
    className={bindClasses('wrapper')}
    data-ppuc-id="AppMenu"
  >
    <div className={bindClasses('tabs-container')}>
      {(tabs && tabs.length > 0) && (
        <Tabs {...{ tabs }} RouterLink={RouterLink} routerMode={routerMode} withoutBorderBottom />
      )}
    </div>
    <div className={bindClasses('child-container')}>
      {children}
    </div>
  </div>
);

AppMenu.defaultProps = {
  tabs: null,
  children: null,
  RouterLink: null,
  routerMode: 'legacy',
};

export default AppMenu;
